<div>
  <ng-container *ngIf="showError">
    <div class="alert alert-danger">
      There was an error logging in, please logout and try again. If this
      problem persists please contact customer service
    </div>
  </ng-container>
</div>
